import {useEffect} from "react";
import {useLogout} from "./useLogout";
import {FullPageSpinner} from "../components/loading/Spinner";
import {Navigate} from "react-router-dom";

export const LogoutPage = () => {
  const {logout, error, loading} = useLogout();

  useEffect(() => {
    if (logout) {
      logout().then((postLogoutRedirect) => {
        window.location.assign(postLogoutRedirect);
      });
    }
  }, [logout]);

  if (loading) {
    return <FullPageSpinner />;
  }
  if (error) {
    return <Navigate to="/error?error=logout" />;
  }
  return <FullPageSpinner />;
};
